let activeFilter = null;

function groupItemsByInitial(arr) {
  const groups = {};

  arr.forEach((item) => {
    // Quitar acentos y caracteres diacríticos
    const normalized = item.title
      .normalize("NFD") // separa letras de los diacríticos
      .replace(/[\u0300-\u036f]/g, ""); // elimina los diacríticos

    const firstChar = normalized.charAt(0).toUpperCase();
    const category = firstChar.match(/[A-Z]/) ? firstChar : "0-9";

    if (!groups[category]) {
      groups[category] = [];
    }
    groups[category].push(item);
  });

  return groups;
}

function renderIndex(groups) {
  const indexContainer = document.querySelector(".brand-index");
  indexContainer.innerHTML = "";

  
  const span = document.createElement("span");
  span.classList.add("brand-filter");
  span.textContent = 'Todas';
  span.onclick = () => showAll();
  indexContainer.appendChild(span);
  const separator = document.createElement("span");
  separator.classList.add("brand-separator");
  separator.textContent = " / ";
  indexContainer.appendChild(separator);

  const keys = Object.keys(groups).sort();
  keys.forEach((letter, index) => {
    const span = document.createElement("span");
    span.classList.add("brand-filter");
    span.textContent = letter;
    span.onclick = () => toggleFilter(letter, span);
    indexContainer.appendChild(span);

    if (index < keys.length - 1) {
      const separator = document.createElement("span");
      separator.classList.add("brand-separator");
      separator.textContent = " / ";
      indexContainer.appendChild(separator);
    }
  });
}

function renderGroups(groups) {
  const container = document.querySelector(".brand-grid");
  container.innerHTML = "";

  Object.keys(groups)
    .sort((a, b) => a.localeCompare(b, 'es', { sensitivity: 'base' })) // ordena A-Z con tildes correcto
    .forEach((letter) => {
      const section = document.createElement("div");
      const section2 = document.createElement("div");
      section.classList.add("brand-group");
      section.id = `group-${letter}`;

      const header = document.createElement("h4");
      header.textContent = `${letter}`;
      section.appendChild(header);

      groups[letter]
        .sort((a, b) => a.title.localeCompare(b.title, 'es', { sensitivity: 'base' })) // ordena interno correcto
        .forEach((item) => {
          const brand = document.createElement("a");
          brand.textContent = `${item.title}`;
          brand.href = item.url;
          section2.appendChild(brand);
        });

      section.appendChild(section2);
      container.appendChild(section);
    });

  showAll();
}


function toggleFilter(letter, button) {
  const sections = document.querySelectorAll(".brand-group");
  const buttons = document.querySelectorAll(".brand-filter");

  if (activeFilter === letter) {
    activeFilter = null;
    sections.forEach((sec) => (sec.style.display = "block"));
    console.log(buttons);
    buttons.forEach((btn) => btn.classList.remove("active"));
  } else {
    activeFilter = letter;
    sections.forEach((sec) => (sec.style.display = "none"));
    document.getElementById(`group-${letter}`).style.display = "block";

    buttons.forEach((btn) => btn.classList.remove("active"));
    button.classList.add("active");
  }
}

function showAll() {
  document
    .querySelectorAll(".brand-group")
    .forEach((sec) => (sec.style.display = "block"));

    const buttons = document.querySelectorAll(".brand-filter");
    buttons.forEach((btn) => btn.classList.remove("active"));
    activeFilter = null;
}

const groupedData = groupItemsByInitial(brands);
renderIndex(groupedData);
renderGroups(groupedData);
